import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-ink py-16 sm:py-24" data-id="element-100" data-mp="26k9wuh2e19bf">
      <div className="mx-auto max-w-6xl px-4" data-id="element-101" data-mp="22lkcg4ixmria">
        <SectionHeading title={<>From random testing to a <span className="text-brand" data-id="element-103" data-mp="2zba3kzs3sr6s">clear diagnostic process</span></>} data-id="element-102" data-mp="22ioeig7342tu" />

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-104" data-mp="2uc6wl9skcaw6">
          <div className="rounded-3xl border-2 border-alert bg-alert-soft p-5 sm:p-7" data-id="element-105" data-mp="2ucqe4peawx9o">
            <div className="mb-5 flex items-center gap-3" data-id="element-106" data-mp="2q8semdl2dkg3">
              <span className="rounded-lg bg-alert px-3 py-1 font-display text-2xl font-black uppercase text-white" data-id="element-107" data-mp="2lbs8k2o7shoz">Before</span>
              <span className="font-display text-xl font-bold uppercase text-white/90" data-id="element-108" data-mp="1evydni6h2eat">Unstructured troubleshooting</span>
            </div>
            <ul className="space-y-3" data-id="element-109" data-mp="19ygdohafn9ey">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-ink/60 p-3.5" data-id="element-110" data-mp="1765osrsv0gve">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert" data-id="element-111" data-mp="1c3nwkev54q1t">
                    <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-112" data-mp="y70n5cm047f0" />
                  </span>
                  <span className="text-base text-white" data-id="element-113" data-mp="of4pu3rqolbu">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-ok bg-ok-soft p-5 sm:p-7" data-id="element-114" data-mp="t6d0120w8aq2">
            <div className="mb-5 flex items-center gap-3" data-id="element-115" data-mp="feziftmjpmxo">
              <span className="rounded-lg bg-ok px-3 py-1 font-display text-2xl font-black uppercase text-ink" data-id="element-116" data-mp="fcdb9v3kh9fz">After</span>
              <span className="font-display text-xl font-bold uppercase text-white/90" data-id="element-117" data-mp="5fgz9fegm56o">The No-Start Pathway™</span>
            </div>
            <ul className="space-y-3" data-id="element-118" data-mp="adsa9tghqlqh">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-ink/60 p-3.5" data-id="element-119" data-mp="2c4j2qhcm9ksa">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-120" data-mp="27dao96wfj989">
                    <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-121" data-mp="23d0hhs0tcesc" />
                  </span>
                  <span className="text-base text-white" data-id="element-122" data-mp="1yeparq5tekec">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-123" data-mp="2r10bd0tf8lb5">
          <p className="font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-124" data-mp="2qzfdb17wek8j">
            One vehicle problem. Six organized stages. <span className="text-brand" data-id="element-125" data-mp="2h2ar51e1yorq">One documented diagnostic workflow.</span>
          </p>
          <p className="mt-4 text-lg text-body" data-id="element-126" data-mp="1anjtd6k87k1x">
            The objective isn’t to replace parts faster. It’s to make every diagnostic decision more systematic.
          </p>
        </div>

        <CtaButton className="mt-10" label="I Want the “After” Workflow" data-id="element-127" data-mp="vl1mn632wzc3" />
      </div>
    </section>;
}